import React, { forwardRef, useState } from 'react'
import { FieldTypes } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import TwistLockMappingFormV2 from './TwistLockMappingFormV2';
import { urlRegexValidator } from 'utils/formUtils';
import { Alert } from 'antd';
import { isEmpty } from 'lodash';
import { PRISMA_TWISTLOCK_URL } from 'utils/documentationUtil';

function TwistLockCredentialsForm(props, ref){
    const [apiEndpoints, setApiEndPoints] = useState(() => ({
        apiEndpoint: props.config?.apiEndpoint,
        codeApiEndpoint: props.config?.codeApiEndpoint,
    }));

    const apiValidation = () => {
        if(isEmpty(apiEndpoints?.["apiEndpoint"]) && isEmpty(apiEndpoints?.["codeApiEndpoint"])){
            return Promise.reject("Please add one of the API endpoints.")
        }
        return Promise.resolve()
    };

    const fields = [{
        name: "apiEndpoint",
        label: "API Endpoint (Prisma Runtime Security)",
        rules: [urlRegexValidator(), {
            validator: apiValidation,
        }],
        props: {
            onChange: (e) => {
                setApiEndPoints(prev => ({ ...prev, apiEndpoint: e.target.value }))
            }
        },
        help: PRISMA_TWISTLOCK_URL
    },
    {
        name: "codeApiEndpoint",
        label: "API Endpoint (Prisma Application Security)",
        rules: [urlRegexValidator(), {
            validator: apiValidation,
        }],
        props: {
            onChange: (e) => {
                setApiEndPoints(prev => ({ ...prev, codeApiEndpoint: e.target.value }))
            }
        },
        help: PRISMA_TWISTLOCK_URL,
    },
    {
        name: "adminConsoleUrl",
        label: "Admin Console URL",
        help: <>Please enter your Prisma Tenant URL (For example: <a href="https://app2.prismacloud.io" target="_blank"  rel="noopener noreferrer">https://app2.prismacloud.io</a>)</>,
        required: true,
        rules:[urlRegexValidator],
    },
    {
        name: "username",
        label: "Access Key",
        required: true
    }, {
        name: "password",
        label: "Secret Key",
        type: FieldTypes.PASSWORD,
        required: true
    }, {
        name: "message",
        type: FieldTypes.LABEL,
        value: <Alert type='warning' message="CI Images for this integration will be available after few minutes of adding the credentials, since they are pulled in background."/>
    }];
    
    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            versionField={false}
            MappingForm={TwistLockMappingFormV2}
        />
    )
}

export default forwardRef(TwistLockCredentialsForm);

export const SUPPORT_URL = <>For details please refer: <a href={"/api/jwt/zendesk/sso?return_to=https://support.armorcode.com/hc/en-us/articles/19405383355667-Prisma-Cloud-Redlock#01J469795PANHH2AJ5CBCRR4QG"} target="_blank"  rel="noopener noreferrer">Documentation</a></>